import React, {useEffect, useRef, useState} from 'react';
import {Col, Form, Row, Tabs, message, Badge, Spin,} from 'antd';
import ProForm, {ProFormInstance} from '@ant-design/pro-form';
import {FileUploadUtility, WdiFileList} from '@/components/WdiControls/WdiFileUpload';
import TabPane from '@ant-design/pro-card/lib/components/TabPane';
import DynamicInformation from '../../components/DynamicInformation';
import {FormPageProps, WdiFormPageTitle} from '@/components/WdiBus/FormPage';
import {getFormStatusName, initApprovalPageContext, ViewEntityProps} from '../../components/data';
import {ResponseStatus} from '@/utils/request';
import DataStore from '@/components/GridWidget/DataStore';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {WdiCardTitle, wdiCore, WdiInput, WdiStaffCard} from '@/components/WdiControls';
import {Enum} from '@/enums/system';
import {FormSa, FormSaDetail} from '@/services/sales/sa';
import {SAWarningApprovalApp} from '../../components/WarningInformation';
import FormSaDetailGroupPanel from '../../components/FormSADetailGroup';
import {FormSaDetailsForApprovalPanel} from '../../GeneralActivityApply/components/Details';
import {SalesAndCostSoldTo, SalesAndCostRegion} from '../../components/SalesAndCost';
import {ProjectToolTipApp} from '../../components/ProjectCmpt';
import BudgetInformation from '../../components/BudgetInformation';
import {WdiEditor} from "@/components/WdiControls/WdiEditor";

const moreConfig: any = {
  successParams: [
    {
      url: "/basicapi/favorite/getButtons",
      keys: []
    }, {
      url: "/expenseapi/saButtons/get",
      keys: [
        "UndoButton",
        "ReeditButton",
        "CancelButton",
        "CopyButton",
        "InterveneFlowButton",
        "AppendExtNodeButton",
        "TransferNodeButton",
        "ClosedButton",
        "OpenedButton",
        "UpdateApplyButton",
        'SettleButton',
        "PaymentButton",
        // "ViewProcessButton",
        "ModifyAmountButton",
        "ModifyPaymentMethodButton",
        "ViewSfaCollectionDetailsButton",
        "AddMailApproverButton",
        "FormSpPrintButton",
        "ExpediteFlowButton",
      ]
    }
  ],
  errorParams: [
    {
      url: "/expenseapi/saButtons/get",
      keys: [
        "RepairButton",
        "InterveneFlowButton"
      ]
    }
  ]
};

const approvalConfig: any = {
  params: {
    url: "/expenseapi/saButtons/get",
    keys: [
      "ApprovalButton",
      "ReadButton",
    ]
  }
};

const GeneralActivityApprovalApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [entity, setEntity] = useState<ViewEntityProps>();
  const [warningCount, setWarningCount] = useState<number>(0);
  const [activeKey, setActiveKey] = useState<string>("1");
  useEffect(() => {
    if (!formRef?.current) {
      return;
    }
    setActiveKey(props.data?.defaultActiveKey ?? "1");
  }, [!!(formRef?.current)])

  useEffect(() => {
    (async () => {
      const params = props.data;
      if (params) {
        const result = await initApprovalPageContext(params);
        if (result.code !== ResponseStatus.SUCCESS) {
          message.error(result.message);
          return;
        }
        const viewEntity: ViewEntityProps = result.data;
        if (viewEntity.form) {
          formRef.current?.setFieldsValue({
            isSpecialApprove: viewEntity.form.isSpecialApprove
          })
        }
        if (viewEntity.formSa) {
          formRef.current?.setFieldsValue({
            activityName: viewEntity.formSa?.activityName,
            activityDate: wdiCore.Date.Join(viewEntity.formSa?.activityStartDate, viewEntity.formSa?.activityEndDate),
            supplyDate: wdiCore.Date.Join(viewEntity.formSa?.supplyStartDate, viewEntity.formSa?.supplyEndDate),
            fileInfo: FileUploadUtility.parse(viewEntity.formSa?.fileName, viewEntity.formSa?.filePath),
            remark: viewEntity.formSa?.remark,
            project: viewEntity.budgetProject
          });

          const formSaId = viewEntity.formSa?.formSaId ?? 0;

          FormSa.Buttons.countOfWarning(formSaId).then(response => {
            setWarningCount(response.data);
          });

          FormSaDetail.getsEx(formSaId).then((response) => {
            response.data?.forEach((item) => {
              if (item.activityStartDate == null) {
                item.activityStartDate = viewEntity.formSa?.activityStartDate?.toString();
              }
              if (item.activityEndDate == null) {
                item.activityEndDate = viewEntity.formSa?.activityEndDate?.toString();
              }
              if (item.supplyStartDate == null) {
                item.supplyStartDate = viewEntity.formSa?.supplyStartDate?.toString();
              }
              if (item.supplyEndDate == null) {
                item.supplyEndDate = viewEntity.formSa?.supplyEndDate?.toString();
              }
            });
            setDataSource(DataStore.init(response.data));
          });
        }
        setEntity(viewEntity);
      }
    })();
  }, [props.data]);

  useEffect(() => {
    if (props.setPageTitle && entity) {
      let title = `通用类活动申请单【${entity.form?.formNo}】`;
      getFormStatusName(entity).then(response => {
        title += `,${response}`;
        if (entity?.form?.relationType === 2) {
          title += '（变更申请）';
        }
        if (props.setPageTitle) props.setPageTitle(
          <WdiFormPageTitle
            title={title}
            onClose={props.onClose}
            callback={props.callback}
            form={entity?.form}
            useCaseId={Enum.UseCase.SA}
            moreConfig={moreConfig}
            approvalConfig={approvalConfig}/>
        );
      });
    }
  }, [props.setPageTitle, entity]);

  return (
    <>
      <WdiStaffCard formId={entity?.form?.formId}/>
      <Tabs activeKey={activeKey} onTabClick={(key, _) => setActiveKey(key)} size="large">
        <TabPane tab={<span>活动信息</span>} key="1">
          <ProForm
            formRef={formRef}
            submitter={{
              render: () => {
                return (<></>)
              },
            }}
          >
            <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.BASE_INFO} title='活动基本信息'/>} collapsed={true}>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={8}>
                  <Form.Item name="activityName" label="活动名称">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="activityDate" label="活动期间">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="supplyDate" label="供货期间">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="project" label="专项项目">
                    <ProjectToolTipApp/>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={16}>
                  <Form.Item name="remark" label="方案简述">
                    <WdiEditor readOnly={true}/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                  <Form.Item
                    name="fileInfo"
                    label="附件"
                    valuePropName='fileList'
                    getValueFromEvent={(e: any) => {
                      return e.fileList || [];
                    }}
                  >
                    <WdiFileList
                      fileList={FileUploadUtility.parse(entity?.formSa?.fileName, entity?.formSa?.filePath)}/>
                  </Form.Item>
                </Col>
              </Row>
            </WdiPanel>
          </ProForm>
          {entity?.form?.formId && (
            <FormSaDetailGroupPanel formId={entity?.form?.formId}/>
          )}
          <FormSaDetailsForApprovalPanel
            data={{ecFieldConfigs: entity?.ecFieldConfigs, form: entity?.form, formSa: entity?.formSa}}
            dataSource={dataSource}/>
        </TabPane>
        <TabPane tab={<span>预算信息</span>} key="2">
          <BudgetInformation formId={entity?.form?.formId}/>
        </TabPane>
        {entity?.boLevelSoldToOpts && entity.boLevelSoldToOpts.length > 0 && dataSource.length > 0 && (
          <TabPane tab={<span>销量与费用(客户)</span>} key="3-1">
            <SalesAndCostSoldTo
              formSa={entity?.formSa}
              formSaDetails={dataSource}
              boLevelOpts={entity?.boLevelSoldToOpts}
            />
          </TabPane>
        )}
        {entity?.boLevelRegionOpts && entity?.boLevelRegionOpts.length > 0 && dataSource.length > 0 && (
          <TabPane tab={<span>销量与费用(区域)</span>} key="3-2">
            <SalesAndCostRegion
              formSa={entity?.formSa}
              formSaDetails={dataSource}
              boLevelOpts={entity?.boLevelRegionOpts}
            />
          </TabPane>
        )}
        <TabPane
          tab={
            <>
              <span>警示信息</span>
              <Badge
                count={warningCount}
                style={{
                  color: "black",
                  boxShadow: "none",
                  background: "none",
                  top: "-20px",
                  right: "-15px",
                  position: 'absolute'
                }}>
              </Badge>
            </>
          }
          key="4"
        >
          <SAWarningApprovalApp formId={entity?.form?.formId}/>
        </TabPane>
        <TabPane tab={<span>动态信息</span>} key="5">
          {
            entity?.form ? <DynamicInformation
              formId={entity?.form?.formId}
              formTypeId={entity?.form?.formTypeId}
              pageTypeId={entity?.form?.pageTypeId}
              useCaseId={Enum.UseCase.SA}
            /> : <Spin/>
          }
        </TabPane>
      </Tabs>
    </>
  );
};
export default GeneralActivityApprovalApp;
